<template>
  <div class="wrapper">
    <div class="box-info adress">
      <div
        class="item"
        v-for="(item,index) in addressList"
        :key="index"
        :class="{'active':curAddressIndex==index}"
      >
        <div class="name">{{item.name}}</div>
        <div class="tel">{{item.mobile}}</div>
        <div class="address">{{item.area_name}} {{item.address}}</div>
        <div>
          <span class="change" @click="modifyAddress(item)">修改</span>
          <span class="remove" @click="removeAddress(item)">删除</span>
          <span class="default" @click="setDefault(item)" v-show="item.is_def!=1">设为默认</span>
        </div>
        <div class="default-icon" v-show="item.is_def==1">
          <i class="icon iconfont icondefault"></i>
        </div>
      </div>
      <div class="add-adress item" @click="addAddressFunc">
        <i class="icon iconfont iconadd"></i>
        添加收货地址
      </div>
    </div>
    <SelectAddress
      :dialogAdressVisible="dialogAddressShow"
      @hideDialog="hideDialog"
      :data="modifyData"
      :type="addressDialogType"
    ></SelectAddress>
  </div>
</template>

<script>
import SelectAddress from "@/components/address/index";
import { mapActions } from "vuex";
export default {
  name: "Address",
  components: { SelectAddress },
  props: {},
  data() {
    return {
      dialogAdressVisible: false,

      modifyData: null,
      dialogAddressShow: false,
      addressDialogType: 0,
      curAddressIndex: -1,
      modifyData: null,
      dialogAddressShow: false
    };
  },
  watch: {},
  computed: {
    addressList() {
      return this.$store.state.addressList;
    }
  },
  methods: {
    ...mapActions(["getUserShipListAction"]),
    hideDialog() {
      this.dialogAddressShow = false;
    },
    addAddressFunc() {
      this.dialogAddressShow = true;
      this.modifyData = {};
    },
    removeAddress(item) {
      this.$api.removeShip({ id: item.id }).then(res => {
        if (res.status) {
          this.$msg("删除成功");
          this.getUserShipListAction();
        }
      });
    },
    modifyAddress(item) {
      this.modifyData = item;
      this.dialogAddressShow = true;
    },
    setDefault(item) {
      this.$api.setDefShip({ id: item.id }).then(res => {
        if (res.status) {
          this.$msg("设置默认地址成功");
          this.getUserShipListAction(); //添加成功获取最新列表
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getUserShipListAction();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";

.box-info {
  padding: 20px 0px;
  display: flex;
  align-items: center;
  font-size: 14px;
  flex-flow: row wrap;
  &.invoice {
    span {
      padding: 0 5px;
      color: #666;
      &.modify {
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
      }
    }
  }
  &.adress {
    .item {
      width: 270px;
      height: 180px;
      border: 1px solid $border;
      text-align: left;
      cursor: pointer;
      padding: 20px;
      box-sizing: border-box;
      position: relative;
      margin-left: 20px;
      margin-bottom: 20px;
      transition: all 0.25s linear;
      .default-icon {
        position: absolute;
        top: 0;
        right: 0;
        .icon {
          font-size: 48px;
          color: $theme-color;
        }
      }
      &:hover {
        border-color: #333;
        .change,
        .remove,
        .default {
          visibility: visible;
        }
      }
      .name {
        line-height: 30px;
        font-size: 24px;
        margin-bottom: 10px;
      }
      .tel,
      .address {
        line-height: 22px;
        color: #757575;
        margin-bottom: 5px;
      }
      .change {
        position: absolute;
        right: 60px;
        bottom: 20px;
        padding: 2px 4px;
        cursor: pointer;
        color: $theme-color;
        visibility: hidden;
      }
      .remove {
        position: absolute;
        right: 14px;
        bottom: 20px;
        padding: 2px 4px;
        cursor: pointer;
        color: $theme-color;
        visibility: hidden;
      }
      .default {
        position: absolute;
        left: 14px;
        bottom: 20px;
        padding: 2px 4px;
        cursor: pointer;
        color: $theme-color;
        visibility: hidden;
      }
      &.add-adress {
        text-align: center;
        color: #999;
        transition: all 0.4s ease;
        &:hover {
          color: #333;
          .icon {
            color: #333;
          }
        }
        .icon {
          display: block;
          width: 30px;
          height: 30px;
          margin: 43px auto 8px;
          font-size: 30px;
          line-height: 30px;
          border-radius: 17px;
          transition: all 0.4s ease;
          color: #e0e0e0;
        }
      }
    }
  }
}
</style>